import React from 'react';
import { connect } from 'react-redux'
import { clearStore, getCurrentUserData } from '../actions/user'
import { openPopup } from '../actions/popup'
import ProfileEdit from './ProfileEdit'
import { getRoleName } from '../lib/dictionary';

function UserProfile({ clearStore, user, openPopup, getCurrentUserData }) {
  const editProfile = async(e) => {
    e.preventDefault()
    if (window.location.href.includes('/onewin') || window.location.href.includes('/lpo')) {
      openPopup('Редактирование профиля', <ProfileEdit />)
    } else
      getCurrentUserData(user.data.id, true)
  }

  return (
    <form className='auth-profileForm'>
      <p className="auth-label clr-yellow">{user.data.name}</p>

      <label className="auth-label clr-white fs-14 mt-16">Роль:</label>
      <p className="auth-label clr-yellow fs-18">{getRoleName(user.role)}</p>

      <label className="auth-label clr-white fs-14 mt-8">E-mail:</label>
      <p className="auth-label clr-yellow fs-18">{user.data.object.ae9dd1b1032daaed7cc9638180dc6318b.Email}</p>

      <label className="auth-label clr-white fs-14 mt-8">Наименование компании:</label>
      <p className="auth-label clr-yellow fs-18">{user.data.object.ae9dd1b1032daaed7cc9638180dc6318b.Company.value || 'Не указано'}</p>

      <button onClick={editProfile} className="auth-button mt-16">Редактировать</button>
      <br />
      <button onClick={e => { e.preventDefault(); clearStore(); }} className="auth-button red mt-16">Выйти</button>
    </form>
  )
}

const mapStateToProps = state => ({
  user: state.user
})

export default connect(mapStateToProps, { clearStore, openPopup, getCurrentUserData })(UserProfile)